import { useModal, Icon } from '@leroy-merlin-br/backyard-react'
import { InfoCircleOutline } from '@backyard-ui/icons'

import DiscountsModal from '../DiscountsModal'

type Props = {
  discount: number
  totalDiscountsByType: string
  paymentMethods?: string
  firstCheapestPaymentMethod?: string
  isPaymentPage?: boolean
}

const DiscountsInfoOpenButton = ({
  discount,
  totalDiscountsByType,
  paymentMethods,
  firstCheapestPaymentMethod,
  isPaymentPage = false
}: Props) => {
  const { setModal } = useModal()

  const renderDiscountsModal = () => {
    setModal({
      size: 'kilo',
      onClose: () => {},
      children: ({ onClose }) => (
        <DiscountsModal
          onClose={onClose}
          discount={discount}
          totalDiscountsByType={JSON.parse(totalDiscountsByType)}
          paymentMethods={paymentMethods}
          firstCheapestPaymentMethod={firstCheapestPaymentMethod}
          isPaymentPage={isPaymentPage}
        />
      )
    })
  }

  return (
    <a data-testid="info-icon" onClick={() => renderDiscountsModal()}>
      {<Icon as={InfoCircleOutline} />}
    </a>
  )
}

export default DiscountsInfoOpenButton
